export const SET_DATA = 'SET_DATA'

export const setData = payload => dispatch =>
  dispatch({
    type: SET_DATA,
    payload: payload
  })
